import React from "react";
import { PATH_FAQ } from "../utils/constants";
import { FAQSection } from "../components/common/FAQSection";
import { JsonLd } from "../components/common/JsonLd";
import { FAQData } from "../types/faq";
import faqs from "../data/faqs.json";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { buildFaqPageGraph } from "../utils/structured-data";

export default function FAQsPage() {
  const faqData = faqs as FAQData;

  return (
    <>
      <SEOHelmet page="faqs" pathname={PATH_FAQ} />
      <JsonLd data={buildFaqPageGraph(faqData)} />
      <main id="main-content" tabIndex={-1} className="relative isolate overflow-hidden">
        <h1 className="sr-only">Häufige Fragen</h1>
        <FAQSection faqs={faqData.faqs} />
      </main>
    </>
  );
}
